// Libraries
import { eachYearOfInterval } from 'date-fns';

/**
 * Retrieves an array of years between two dates (inclusive).
 *
 * @param startDate - The starting date in local time.
 * @param endDate - The ending date in local time.
 * @returns An array of years between startDate and endDate (inclusive).
 *
 * @remarks
 * This function uses the `eachYearOfInterval` function from `date-fns`
 * to calculate the years within the provided interval.
 *
 *
 * @example
 * ```typescript
 * const startDate = new Date('2010-01-01');
 * const endDate = new Date('2020-12-31');
 * const years = getYearsBetweenDates(startDate, endDate);
 * // Result: [2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020]
 * ```
 */
export const getYearsBetweenDates = (startDate: Date, endDate: Date) => {
  startDate.setHours(startDate.getHours() + startDate.getTimezoneOffset() / 60);
  endDate.setHours(endDate.getHours() + endDate.getTimezoneOffset() / 60);
  const years = eachYearOfInterval({
    start: startDate,
    end: endDate,
  });

  return years.map((year) => year.getFullYear());
};
